import appSagas from '../modules/app/app.saga';
import registrationSagas from '../modules/app/initial-content/registration/registration.saga';
import verificationSagas from '../modules/app/initial-content/verification/verification.saga';
import loginSagas from '../modules/app/initial-content/login/login.saga';
import forgotPasswordSagas from '../modules/app/initial-content/forgot-password/forgot-password.saga';
import passwordRecoverySagas from '../modules/app/initial-content/password-recovery/password-recovery.saga';
import verificationSetupSagas from '../modules/app/initial-content/verification-setup/verification-setup.saga';
import logoutSagas from '../modules/app/content/logout/logout.saga';
import notificationsSagas from '../modules/app/notifications/notifications.saga';
import commentsSagas from '../modules/app/comments/comments.saga';
import controlsSagas from '../modules/app/controls/controls.saga';
import exportModalSagas from '../modules/app/controls/export-modal/export-modal.saga';
import importModalSagas from '../modules/app/controls/import-modal/import-modal.saga';
import searchListSagas from '../modules/app/search-list/search-list.saga';
import searchSagas from '../modules/search/search.saga';
import settingsSagas from '../modules/settings/settings.saga';
import settingsAccountListSagas from '../modules/settings/settings-account-list/settings-account-list.saga';
import settingsAccountSagas from '../modules/settings/settings-account/settings-account.saga';
import settingsOperationLogSagas from '../modules/settings/settings-operation-log/settings-operation-log.saga';
import settingsDealTemplateListSagas
  from '../modules/settings/settings-deal-template-list/settings-deal-template-list.saga';
import settingsDealTemplateSagas from '../modules/settings/settings-deal-template/settings-deal-template.saga';
import settingsPortfolioGroupListSagas
  from '../modules/settings/settings-portfolio-group-list/settings-portfolio-group-list.saga';
import settingsPortfolioGroupSagas from '../modules/settings/settings-portfolio-group/settings-portfolio-group.saga';
import settingsPortfolioSagas from '../modules/settings/settings-portfolio/settings-portfolio.saga';
import settingsUserListSagas from '../modules/settings/settings-user-list/settings-user-list.saga';
import settingsUserSagas from '../modules/settings/settings-user/settings-user.saga';
import settingsProfileSagas from '../modules/settings/settings-profile/settings-profile.saga';
import settingsSecuritySagas from '../modules/settings/settings-security/settings-security.saga';
import settingsNotificationsSagas from '../modules/settings/settings-notifications/settings-notifications.saga';
import dashboardSagas from '../modules/dashboard/dashboard.saga';
import assetListSagas from '../modules/asset-list/asset-list.saga';
import assetSagas from '../modules/asset/asset.saga';
import activityListSagas from '../modules/activity-list/activity-list.saga';
import activitySagas from '../modules/activity/activity.saga';
import dealListSagas from '../modules/deal-list/deal-list.saga';
import dealSagas from '../modules/deal/deal.saga';
import dealTermsSagas from '../modules/deal/deal-terms/deal-terms.saga';
import dealValuationFilesSagas from '../modules/deal/deal-valuation-files/deal-valuation-files.saga';
import dealTasksSagas from '../modules/deal/deal-tasks/deal-tasks.saga';
import dealSchedulesSagas from '../modules/deal/deal-schedules/deal-schedules.saga';
import dealParticipantsSagas from '../modules/deal/deal-participants/deal-participants.saga';
import dealFilesSagas from '../modules/deal/deal-files/deal-files.saga';
import contactListSagas from '../modules/contact-list/contact-list.saga';
import contactSagas from '../modules/contact/contact.saga';
import reportListSagas from '../modules/report-list/report-list.saga';
import reportSagas from '../modules/report/report.saga';

export default {
  app: appSagas(),
  registration: registrationSagas(),
  verification: verificationSagas(),
  login: loginSagas(),
  forgotPassword: forgotPasswordSagas(),
  passwordRecovery: passwordRecoverySagas(),
  verificationSetup: verificationSetupSagas(),
  logout: logoutSagas(),
  notifications: notificationsSagas(),
  comments: commentsSagas(),
  controls: controlsSagas(),
  exportModal: exportModalSagas(),
  importModal: importModalSagas(),
  searchList: searchListSagas(),
  search: searchSagas(),
  settings: settingsSagas(),
  settingsAccountList: settingsAccountListSagas(),
  settingsAccount: settingsAccountSagas(),
  settingsOperationLog: settingsOperationLogSagas(),
  settingsDealTemplateList: settingsDealTemplateListSagas(),
  settingsDealTemplate: settingsDealTemplateSagas(),
  settingsPortfolioGroupList: settingsPortfolioGroupListSagas(),
  settingsPortfolioGroup: settingsPortfolioGroupSagas(),
  settingsPortfolio: settingsPortfolioSagas(),
  settingsUserList: settingsUserListSagas(),
  settingsUser: settingsUserSagas(),
  settingsProfile: settingsProfileSagas(),
  settingsSecurity: settingsSecuritySagas(),
  settingsNotifications: settingsNotificationsSagas(),
  dashboard: dashboardSagas(),
  assetList: assetListSagas(),
  asset: assetSagas(),
  activityList: activityListSagas(),
  activity: activitySagas(),
  dealList: dealListSagas(),
  deal: dealSagas(),
  dealTerms: dealTermsSagas(),
  dealValuationFiles: dealValuationFilesSagas(),
  dealTasks: dealTasksSagas(),
  dealSchedules: dealSchedulesSagas(),
  dealParticipants: dealParticipantsSagas(),
  dealFiles: dealFilesSagas(),
  contactList: contactListSagas(),
  contact: contactSagas(),
  reportList: reportListSagas(),
  report: reportSagas(),
};
